import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';
import { moduleNamespace } from '../../redux/store.config';

export interface PolygonFilterFetchPayload {
	polygon: GeoJSON.Feature<GeoJSON.Polygon>;
	layers: Array<{ layerId: string; systemType: string; assetType: string }>;
}

interface PolygonHighlightState {
	/** layerId → assetIds */
	highlights: Record<string, string[]>;
	loading: boolean;
}

const initialState: PolygonHighlightState = {
	highlights: {},
	loading: false,
};

const polygonHighlightSlice = createSlice({
	name: 'polygonHighlight',
	initialState,
	reducers: {
		polygonFilterFetch(
			state,
			_action: PayloadAction<PolygonFilterFetchPayload>,
		) {
			state.loading = true;
		},
		polygonFilterResolved(
			state,
			action: PayloadAction<Record<string, string[]>>,
		) {
			state.highlights = action.payload;
			state.loading = false;
		},
		polygonFilterRejected(state) {
			state.loading = false;
		},
		clearPolygonHighlights(state) {
			state.highlights = {};
			state.loading = false;
		},
	},
});

export const {
	polygonFilterFetch,
	polygonFilterResolved,
	polygonFilterRejected,
	clearPolygonHighlights,
} = polygonHighlightSlice.actions;

export default polygonHighlightSlice.reducer;

// Selectors
const selectPolygonHighlightBase = (state: DefaultRootState) =>
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	(state as any)[moduleNamespace]?.polygonHighlight as
		| PolygonHighlightState
		| undefined;

export const selectPolygonHighlights = (
	state: DefaultRootState,
): Record<string, string[]> =>
	selectPolygonHighlightBase(state)?.highlights ?? {};

export const selectPolygonHighlightLoading = (
	state: DefaultRootState,
): boolean => selectPolygonHighlightBase(state)?.loading ?? false;
